<template>
  <h3 class="pb5">Dossier actif par intervenant (CDX 0102)</h3>
  <CritereRechercheDivers :cacherChampDate="true" ref="critereRechercheDivers"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import CritereRechercheDivers from "@/components/rapports/Rechercher/CritereRechercheDivers.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersActifsParIntervenant",
  components: {CritereRechercheDivers, ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Divers");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
        });
  },
  methods: {
    assignerResultat(res) {
      if (res.data.entites !== null)
        this.$refs.critereRechercheDivers.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheDivers.getCriteresRecherche();
      criteresRecherche.titre = "DossiersActifsParIntervenant";
      criteresRecherche.nomRapport = "divers.ActifIntervenantDossierGenerateurRapport_CDX_0102";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>